import React, { useMemo, useRef, useCallback, useEffect, useState, createContext } from "react"
import { debounce } from 'lodash'


const defaultValues = {
    scrollActions: {
        update: () => { },
        destroy: () => { },
        scrollTo: () => { },
        registerHandler: () => { }
    },
    scrollInstance: {
        current: null
    }

}

export const ScrollContext = createContext(defaultValues)

export default function ScrollContextWrapper({ children }) {

    const scrollInstance = useRef(null)
    const [regiseredEvents, setRegisteredEvents] = useState(false)

    const runFn = useCallback((fn, ...args) => {
        if (scrollInstance.current) {
            scrollInstance.current[fn](...args)
        }
    }, [])

    const addEvent = useCallback((event, fn) => {
        if (scrollInstance.current) {
            scrollInstance.current.on(event, fn)
        }
    }, [])


    const updateScrollInstance = useCallback(() => {
        runFn('update')
    }, [runFn])


    const destoryScroll = useCallback(() => {
        runFn('destroy')
    }, [runFn])

    const scrollToEl = useCallback((target, options) => {
        runFn('scrollTo', target, options)
    }, [runFn])

    const registerHandler = useCallback((event, fn, interval = 100) => {

        setRegisteredEvents(true)
        const throttledFn = debounce(fn, interval, { maxWait: interval })

        addEvent(event, throttledFn)
    }, [addEvent])

    const destroyScrollEvents = useCallback(() => {
        if (regiseredEvents) {
            destoryScroll()
        }
    }, [regiseredEvents, destoryScroll])

    useEffect(() => {
        return () => destroyScrollEvents()
    }, [destroyScrollEvents])

    const scrollActions = useMemo(() => {
        return {
            update: updateScrollInstance,
            destroy: destoryScroll,
            scrollTo: scrollToEl,
            registerHandler
        }
    }, [updateScrollInstance, destoryScroll, scrollToEl, registerHandler])

    return (
        <ScrollContext.Provider value={{ scrollInstance, scrollActions }}>
            {children}
        </ScrollContext.Provider>
    )
}



